import React from 'react';
import { AuthPage } from '@refinedev/antd';

export const Register: React.FC = () => {
  return <AuthPage type="register" />;
};
